import { TextField, TextFieldProps } from '@portals/core/src/components/TextField/TextField';
import { Field, getIn } from 'formik';
import React, { useCallback } from 'react';

import { usePhoneValidator } from '../../hooks/PhoneValidator/PhoneValidator';
import { teeEvent } from '../../utilties/teeEvent';

type InputMode = TextFieldProps['inputMode'];
type InputType = TextFieldProps['type'];

export type PhoneInputProps = Omit<TextFieldProps, 'name' | 'value' | 'error' | 'pattern'> & {
  name: TextFieldProps['name'];
  helperText?: TextFieldProps['helperText'];
  inputMode?: InputMode;
  type?: InputType;
  placeholder?: TextFieldProps['placeholder'];
  required?: TextFieldProps['required'];
};

/**
 * Phone Form Field
 */
export const PhoneInput = ({
  name,
  helperText,
  type = 'tel' as InputType,
  inputMode = 'tel' as InputMode,
  placeholder = '+49 030 123456',
  required = false,
  slotProps,
  ...props
}: PhoneInputProps): React.ReactElement => {
  const validate = usePhoneValidator({ required });

  const fieldComponent = useCallback(
    ({ form, field: { value, ...field }, ...props }) => {
      //const error = form.touched[name] || value ? Boolean(form.errors[name]) : false;
      const error = (getIn(form.touched, name) && Boolean(getIn(form.errors, name))) || props.error;

      const onBlur = teeEvent(props.onBlur, field.onBlur);
      const onChange = teeEvent(props.onChange, field.onChange);

      return (
        <TextField
          error={error}
          helperText={error ? form.errors[name] : helperText}
          {...field}
          value={value || ''}
          {...props}
          onBlur={onBlur}
          onChange={onChange}
        />
      );
    },
    [helperText, name]
  );

  return (
    <Field
      component={fieldComponent}
      name={name}
      validate={validate}
      placeholder={placeholder}
      required={required}
      slotProps={{
        htmlInput: {
          inputMode,
          type,
          required,
        },
        ...slotProps,
      }}
      {...props}
    />
  );
};
